<template>
  <div class="xl:min-h-screen bg-gray-50 py-12 overflow-auto">
    <div class="container mx-auto px-6 text-center">
      <h1 class="text-4xl font-bold text-[#085f63] mb-6">{{ $t('pricingComponent.title') }}</h1>
      <p class="text-lg text-gray-600 mb-12">{{ $t('pricingComponent.description') }}</p>

      <div class="grid md:grid-cols-3 gap-6">
        <PricingCard
          :title="'pricingComponent.starterTitle'"
          :price="'pricingComponent.starterPrice'"
          :button="'pricingComponent.buyCreditsButton'"
          :features="starterFeatures"
          bgClass='bg-paletteYellow'
          :isRecommended="false"
          :image="coinPileImage" />

        <PricingCard
          :title="'pricingComponent.popularTitle'"
          :price="'pricingComponent.popularPrice'"
          :button="'pricingComponent.buyCreditsButton'"
          :features="popularFeatures"
          bgClass='bg-paletteOrange'
          :isRecommended="true"
          :image="explorerImage" />

        <PricingCard
          :title="'pricingComponent.proTitle'"
          :price="'pricingComponent.proPrice'"
          :button="'pricingComponent.buyCreditsButton'"
          :features="proFeatures"
          bgClass='bg-paletteLightGreen'
          :isRecommended="false"
          :image="masterImage" />
      </div>
    </div>
  </div>
</template>

<script setup>
import PricingCard from '@/components/pricing/PricingCard.vue'
import coinPileImage from '@/assets/icons/coin-pile.png'
import explorerImage from '@/assets/icons/explorer.png'
import masterImage from '@/assets/icons/master.png'

const starterFeatures = [
  'pricingComponent.starterFeature1',
  'pricingComponent.starterFeature2',
  'pricingComponent.starterFeature3'
]

const popularFeatures = [
  'pricingComponent.popularFeature1',
  'pricingComponent.popularFeature2',
  'pricingComponent.popularFeature3'
]

const proFeatures = [
  'pricingComponent.proFeature1',
  'pricingComponent.proFeature2',
  'pricingComponent.proFeature3'
]
</script>
